import React from "react";
import { Outlet } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";

// Toastify
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Layout = () => {
  return (
    <>
      {/* Header */}
      <Header />

      {/* Page Content */}
      <Outlet />

      {/* Footer */}
      <Footer />

      {/* 🔥 Toast Notifications */}
      <ToastContainer
        position="top-right"
        autoClose={3000}   // faster UX
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </>
  );
};

export default Layout;